import React from 'react';
import { isMobile } from 'react-device-detect';
import { Fullscreen, PlayArrowRounded, Chat, SpeakerNotesOff } from '@material-ui/icons';

import volumeOn from '../../../../assets/icons/volume-on.png';
import volumeMuted from '../../../../assets/icons/volume-muted.png';

import './css/AnchorLiveFeedPlayerControls.css';
import './css/AnchorLiveFeedPlayerControls.mobile.css';
import { observer } from 'mobx-react';

import LiveBroadcastStore from '../../../../store/LiveBroadcastStore';


@observer
class AnchorLiveFeedPlayerControls extends React.Component {
  handleVolumeChange = (event) => {
    this.props.onVolumeChange(event.target.value);
  };

  onChatDisabled = () => {
    const { chatDisabled } = LiveBroadcastStore;
    LiveBroadcastStore.setChatDisabled(!chatDisabled);
  };

  render() {
    const {
      muted,
      mutePlayer,
      toggleFullscreen,
      volume,
      showPlay,
      broadcasterClosedSession,
      spotlighterClosedSession,
      playVideo,
      disableMute,
      shouldHideVolumeRange = false,
    } = this.props;
    const { chatDisabled } = LiveBroadcastStore;
    const ChatIcon = chatDisabled ? Chat : SpeakerNotesOff;

    return (
      <>
        {showPlay && !broadcasterClosedSession && !spotlighterClosedSession && (
          <div className="play-button" onClick={playVideo}>
            <PlayArrowRounded fontSize="inherit" />
          </div>
        )}
        <div className="anchor-live-feed-player-controls">
          <div className="volume-container">
            <button
              className="volume-container__cta-mute"
              disabled={disableMute}
              title="Mute/Unmute sound"
              onClick={mutePlayer}
            >
              <span className="icon-sound">
                {!muted ? (
                  <img alt="" src={volumeOn} />
                ) : (
                  <img alt="" src={volumeMuted} />
                )}
              </span>
            </button>
            {!isMobile && !shouldHideVolumeRange && (
              <div className="slider-container">
                <input
                  className="volume-range"
                  max={1}
                  min={0}
                  step={0.1}
                  type="range"
                  value={volume}
                  onChange={this.handleVolumeChange}
                />
              </div>
            )}
          </div>
          {!isMobile && (
            <div title="Switch to full screen" onClick={toggleFullscreen}>
              <span className="icon-fullscreen">
                <Fullscreen fontSize="inherit" />
              </span>
            </div>
          )}
        </div>
        <button
          className="chat-disabled-icon"
          onClick={this.onChatDisabled}
        >
          <ChatIcon />
        </button>
      </>
    );
  }
}

export default AnchorLiveFeedPlayerControls;
